exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-inputGrid-3-3Y5{margin-bottom:15px}.style-cssmodule-recoverPasswordButton-p9bBW{font-weight:700;display:flex;align-items:center;justify-content:center;column-gap:12px;fill:var(--color-white,#fff);stroke:none}.style-cssmodule-title-21Y2-{color:var(--color-blue-middle,#1147b7);font-family:Roboto;font-size:40px;font-style:normal;font-weight:500;line-height:40px;letter-spacing:.4px}.style-cssmodule-messageTopRight-mBYdp{position:fixed;top:30px;right:20px;max-width:90vw}", ""]);

// exports
exports.locals = {
	"inputGrid": "style-cssmodule-inputGrid-3-3Y5",
	"recoverPasswordButton": "style-cssmodule-recoverPasswordButton-p9bBW",
	"title": "style-cssmodule-title-21Y2-",
	"messageTopRight": "style-cssmodule-messageTopRight-mBYdp"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./routes/login/components/cpm_client/components/Recover/style.cssmodule.css
// module id = 2568
// module chunks = 121